import { render, staticRenderFns } from "./eventsetting.vue?vue&type=template&id=0d4753d8"
import script from "./eventsetting.vue?vue&type=script&lang=js"
export * from "./eventsetting.vue?vue&type=script&lang=js"
import style0 from "./eventsetting.vue?vue&type=style&index=0&id=0d4753d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports